<div class="about-content">
    <h3 i18n>Open and Classic Baccarat</h3>
    <div class="about-body">
        <table>
            <tr>
                <th i18n>Backend</th>
                <td i18n>{{ backendVersion }}</td>
            </tr>

            <tr>
                <th i18n>Frontend</th>
                <td>{{ frontendVersion }}</td>
            </tr>
        </table>
    </div>
</div>
